<template>
  <authorization permissionKey="attendance_medical_request" can="read">
    <MedicalRequestListSkeletonLoader v-if="isLoading" class="mx-3 mt-2" />

    <div v-else>
      <v-row v-if="lodash.isEmpty(examsList)" justify="center">
        <v-col cols="6">
          <v-alert color="orange" outlined text type="info">
            Sem solicitações médicas
          </v-alert>
        </v-col>
      </v-row>

      <MedicalRequestListItem
        v-else
        v-for="medicalRequest in examsList"
        :key="medicalRequest.id"
        :attendance="attendance"
        :medicalRequest="medicalRequest"
        :refreshQueue="refreshQueue"
        :disabled="disabled"
      />
    </div>
  </authorization>
</template>

<script>
  import EXAM_REQUESTS from "@/graphql/medical_request/medical_requests.js";
  import MedicalRequestListSkeletonLoader from "@/components/medical_request/list/skeleton_loader.vue";
  import MedicalRequestListItem from "@/components/medical_request/list/item/index.vue";

  export default {
    name: "MedicalRequestList",
    props: {
      attendance: Object,
      exams: {
        type: Array,
        default: null,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      refreshQueueProps: {
        type: Function,
        default: () => [],
      },
      filters: {
        type: Object,
        default: () => ({}),
      }
    },
    components: {
      MedicalRequestListItem,
      MedicalRequestListSkeletonLoader,
    },
    data() {
      return {
        medicalRequests: [],
      };
    },
    mounted() {
      this.refetchMedicalRequests();
    },
    apollo: {
      medicalRequests: {
        query: EXAM_REQUESTS,
        variables() {
          return {
            attendanceId: this.attendance.id,
            filters: this.filters,
          };
        },
        update(data) {
          return this.lodash.orderBy(data.medicalRequests, ["createdAt"], ["desc"]);
        },
        pollInterval: 5000,
        skip() {
          return this.exams !== null;
        },
      },
    },
    watch: {
      filters() {
        this.refetchMedicalRequests();
      }
    },
    computed: {
      examsList() {
        if (this.exams !== null) {
          return this.exams;
        }

        return this.medicalRequests;
      },
      isLoading() {
        return this.$apollo.queries.medicalRequests.loading;
      },
    },
    methods: {
      refreshQueue() {
        if (this.exams !== null) {
          return this.refreshQueueProps();
        }

        this.refetchMedicalRequests();
      },
      async refetchMedicalRequests() {
        await this.$apollo.queries.medicalRequests.refetch();
      }
    },
  };
</script>

<style lang="scss" scoped></style>
